import { memo, useMemo } from 'react';
import TableHead from '@wg/wows-react-uikit/components/Table/TableHead';
import TableHeadCell from '@wg/wows-react-uikit/components/Table/TableHeadCell';

import headers from './headers.settings';

interface ClansRatingSearchResultTableHeadProps {
  stickyContainerId: string;
}

const ClansRatingSearchResultTableHead = ({ stickyContainerId }: ClansRatingSearchResultTableHeadProps) => {
  const headersCells = useMemo(() => {
    return headers()
      .filter((item) => !item.isHidden)
      .map((item, index) => (
        <TableHeadCell key={index} modify={item.modify} isSortable={false} isActive={false} isHidden={item.isHidden}>
          {item.text}
        </TableHeadCell>
      ));
  }, []);

  return (
    <TableHead stickyContainerId={stickyContainerId}>
      <>{headersCells}</>
    </TableHead>
  );
};

ClansRatingSearchResultTableHead.displayName = 'ClansRatingSearchResultTableHead';

export default memo(ClansRatingSearchResultTableHead);
